import { Component, h, Prop, Host, Event, EventEmitter } from '@stencil/core';

@Component({
    tag: 'sew-ws-floating-buttons-contact-options-option',
    styleUrl: 'sew-ws-floating-buttons-contact-options-option.scss',
    shadow: true,
})
export class SewWsFloatingButtonsContactOptionsOption {
    @Prop() optionTitle: string;
    @Prop() icon: string;
    @Prop() noBack: boolean;
    @Prop() closeCallback: () => void;
    @Event() goBack: EventEmitter<boolean>;
    @Event() closeOption: EventEmitter<boolean>;

    render() {
        return (
            <Host>
                <header>
                    {!this.noBack && (
                        <button
                            class="back"
                            onClick={() => {
                                this.goBack.emit(true);
                            }}
                        >
                            <sew-icon class="icon" icon="arrow-chevron-left" size="l" />
                        </button>
                    )}
                    <div class="title">
                        <sew-icon class="svg" icon={this.icon} />
                        {this.optionTitle}
                    </div>
                    <button
                        class="close"
                        onClick={() => {
                            if (this.closeCallback) {
                                this.closeCallback();
                            }
                            this.closeOption.emit(true);
                        }}
                    >
                        <sew-icon icon="close" />
                    </button>
                </header>
                <div class="content">
                    <slot></slot>
                </div>
            </Host>
        );
    }
}
